import { type GridRowParams } from "@mui/x-data-grid";

import { TableQueryParams } from "api/common/adapters/pagination.types";
import { PaginatedResponse } from "api/common/types/response.types";
import { MailAccount } from "api/memberPortal/mailList/mailList.types";
import ServerSidePaginatedDataGrid from "components/MUI/DataGrid/ServerSidePaginatedDataGrid";

import { mailListMembersColumns } from "./MailListMembers.columns";

interface MailListMembersTableProps {
  memberData: PaginatedResponse<MailAccount>;
  isLoading: boolean;
  tableParams: TableQueryParams;
  onTableParamsChange: (_queryParams: TableQueryParams) => void;
  onMemberSelectChange: (_row: GridRowParams) => void;
}
const columns = mailListMembersColumns;

export default function MailListMembersTable({
  memberData,
  isLoading,
  tableParams,
  onTableParamsChange,
  onMemberSelectChange,
}: MailListMembersTableProps) {
  return (
    <ServerSidePaginatedDataGrid
      data={memberData}
      loading={isLoading}
      title={"Mail List Members"}
      columns={columns}
      initialPaginationModel={{ page: 0, pageSize: 100 }}
      tableParams={tableParams}
      onParamsChange={onTableParamsChange}
      showToolbar={false}
      disableZebraStripes
      onRowClick={onMemberSelectChange}
      sx={{
        "& .MuiDataGrid-row:hover .row-action": {
          opacity: 1,
        },
      }}
    />
  );
}
